module.exports = __webpack_public_path__ + "./MaoChun2_cbc6ca4d9c1dc9f784357bf6cbd90e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/MaoChun2.png
// module id = 569
// module chunks = 0